import MySessions from './MySessions';
export default MySessions;
